/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PairingCodes { 
    /**
     * Device code
     */
    device_code: string;
    /**
     * Seconds after which pairing codes will expire
     */
    expires_in: number;
    /**
     * Expected poll interval in seconds
     */
    interval: number;
    /**
     * User code
     */
    user_code: string;
    /**
     * Verification URI
     */
    verification_uri: string;
    /**
     * Verification URI complete
     */
    verification_uri_complete: string;
}

